import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

export default function TopNav() {

  // Logged in user
  const user = JSON.parse(localStorage.getItem("user"));




  console.log("USER:", user);


const [cartCount, setCartCount] = useState(0);

useEffect(() => {
  const fetchCart = async () => {
    try {
      const res = await fetch("https://eleven11-i6v4.onrender.com/api/cart");
      const data = await res.json();
      const total = (data.items || []).reduce((sum, item) => sum + (item.qty || 1), 0);
      setCartCount(total);
    } catch {}
  };
  fetchCart();
  const interval = setInterval(fetchCart, 5000);
  return () => clearInterval(interval);
}, []);



  const styles = {

   nav: {
  position: "sticky",
  top: 0,
  zIndex: 1000,

  height: "44px",

  display: "flex",
  alignItems: "center",
  justifyContent: "center",

  background: "#F6F7FB",

  borderBottom: "1px solid rgba(0,0,0,0.04)",

  backdropFilter: "none",
  WebkitBackdropFilter: "none",

  boxShadow: "none",
},

    inner: {
      width: "100%",
      maxWidth: "1200px",

      display: "flex",
      alignItems: "center",
      justifyContent: "space-between"
    },

    navGroup: {
      display: "flex",
      alignItems: "center",
      gap: "28px"
    },

   logo: {
  fontSize: "15px",

  fontWeight: 600,

  letterSpacing: "3px",

  cursor: "pointer",

  opacity: 0.92,
},

    link: {
      fontSize: "13px",
      fontWeight: 400,
      color: "#1d1d1f",
      cursor: "pointer",
      opacity: 0.85
    },

    right: {
      display: "flex",
      alignItems: "center",
      gap: "20px"
    },


cartBtn: {
  position: "relative",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: 36,
  height: 36,
  borderRadius: 12,
  background: "rgba(0,0,0,0.05)",
  cursor: "pointer"
},

cartBadge: {
  position: "absolute",
  top: -4,
  right: -4,
  width: 16,
  height: 16,
  borderRadius: "50%",
  background: "#0a84ff",
  color: "#fff",
  fontSize: 10,
  fontWeight: 800,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  border: "2px solid #F6F7FB"
},



    account: {
      fontSize: "13px",
      cursor: "pointer",
      opacity: 0.9
    },

    signup: {
      fontSize: "13px",
      padding: "6px 14px",
      borderRadius: "20px",
      border: "1px solid rgba(0,0,0,0.1)",
      cursor: "pointer"
    }

  };

return (
  <div style={styles.nav}>
    <div style={styles.inner}>

      {/* Logo */}
      <Link to="/" style={{ ...styles.logo, textDecoration: "none", color: "#1d1d1f" }}>
        ELEVEN
      </Link>

      {/* Navigation */}
      <div style={styles.navGroup}>
        <Link to="/category/marine-detailing" style={{ ...styles.link, textDecoration: "none" }}>
          Marine Detailing
        </Link>

        <Link to="/category/lubricants" style={{ ...styles.link, textDecoration: "none" }}>
          Lubricants
        </Link>

        <Link to="/category/accessories" style={{ ...styles.link, textDecoration: "none" }}>
          Accessories
        </Link>

    

        <Link to="/category/new-oem" style={{ ...styles.link, textDecoration: "none" }}>
          New OEM Parts
        </Link>

        <Link to="/category/used-oem" style={{ ...styles.link, textDecoration: "none" }}>
          Used OEM Parts
        </Link>

        <Link to="/category/fluids" style={{ ...styles.link, textDecoration: "none" }}>
          Fluids & Maintenance
        </Link>
      </div>

      {/* Right Side */}
      <div style={styles.right}>
      
      
       <Link to="/account" style={{ ...styles.account, textDecoration: "none", color: "#1d1d1f" }}>
  Account
</Link>




 <Link
  to={user ? "/account" : "/auth"}
  style={{
    ...styles.signup,
    textDecoration: "none",
    color: "#1d1d1f"
  }}
>
  {user ? user.firstName : "Sign up"}
</Link>


<Link to="/checkout" style={{ ...styles.cartBtn, textDecoration: "none" }}>
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#1d1d1f" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/>
    <line x1="3" y1="6" x2="21" y2="6"/>
    <path d="M16 10a4 4 0 01-8 0"/>
  </svg>
  {cartCount > 0 && (
    <span style={styles.cartBadge}>{cartCount}</span>
  )}
</Link>

      </div>

    </div>
  </div>
);
}